import { Badge } from '@/shared/components/ui/badge'
import { safeFormatDateTime } from '@/shared/utils/formatDate'
import { formatAmount } from '@/shared/utils/formatAmount'
import type { CreditMovement } from '../hooks/useCreditMovements'

interface CreditMovementsTableProps {
  movements: CreditMovement[]
  currencyNameById: Map<number, string>
}

/**
 * Historial de movimientos de crédito: fecha, tipo (canal) e importe.
 * SEAM: el endpoint no expone "saldo resultante"; añadir la columna `Saldo`
 * cuando el backend exponga un campo `balanceAfter`.
 */
export function CreditMovementsTable({
  movements,
  currencyNameById,
}: CreditMovementsTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-line text-left text-xs font-semibold uppercase tracking-wide text-ink-subtle">
            <th className="px-2 py-3">Fecha</th>
            <th className="px-2 py-3">Tipo</th>
            <th className="px-2 py-3 text-right">Importe</th>
          </tr>
        </thead>
        <tbody>
          {movements.map((m) => (
            <tr key={m.id} className="border-b border-line last:border-b-0">
              <td className="whitespace-nowrap px-2 py-3 text-ink-muted">
                {safeFormatDateTime(m.createdAt, '—')}
              </td>
              <td className="px-2 py-3">
                <Badge variant="accent">{m.deliveryChannel}</Badge>
              </td>
              <td className="whitespace-nowrap px-2 py-3 text-right font-medium text-ink">
                {formatAmount(m.amount, m.currencyId, currencyNameById)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
